import React, { useRef, useState } from 'react';
import Webcam from 'react-webcam';
import { uploadImages } from '../services/api';
import './UploadPage.css';

const videoConstraints = {
  width: 550,
  height: 300,
  facingMode: 'user',
};

const UploadPage = ({ onSuccess }) => {
  const docCamRef = useRef(null);
  const selfieCamRef = useRef(null);

  const [docImage, setDocImage] = useState(null);
  const [selfieImage, setSelfieImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const captureDoc = () => {
    const imageSrc = docCamRef.current.getScreenshot();
    setDocImage(imageSrc);
  };

  const captureSelfie = () => {
    const imageSrc = selfieCamRef.current.getScreenshot();
    setSelfieImage(imageSrc);
  };

  const handleSubmit = async () => {
    setLoading(true);
    const toBlob = async (base64) => {
      const res = await fetch(base64);
      return await res.blob();
    };
  
    try {
      const docBlob = await toBlob(docImage);
      const selfieBlob = await toBlob(selfieImage);
  
      const response = await uploadImages(
        new File([docBlob], 'document.jpg', { type: 'image/jpeg' }),
        new File([selfieBlob], 'selfie.jpg', { type: 'image/jpeg' })
      );
  
      // Custom API might respond with an error in JSON structure
      if (response.success === false || response.error) {
        onSuccess(
          {
            error: true,
            message: response.message || 'Something went wrong.',
            errorType: response.errorType || null
          },
          true
        );
      } else {
        onSuccess(response, false);
      }
    } catch (err) {
      onSuccess(
        {
          error: true,
          message: err?.message || 'Network error occurred. Try again.',
          errorType: 'network'
        },
        true
      );
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div className="upload-container">
      <h2>Capture Your ID and Selfie</h2>
      <p className="subtitle">Ensure good lighting and center your face/document within the frame.</p>

      <div className="camera-section">
        {/* Step 1 */}
        <div className="camera-box">
          <h2>Step 1 - ID Document</h2>
          <h4>Place your ID Document in the box. Make sure it is clearly visible.</h4>
          <div className="webcam-wrapper">
  <div className={docImage ? 'overlay rectangle' : 'overlay rectangle'}></div>
  {!docImage ? (
    <Webcam
      audio={false}
      ref={docCamRef}
      screenshotFormat="image/jpeg"
      videoConstraints={videoConstraints}
      className="camera-feed"
    />
  ) : (
    <img src={docImage} alt="Document" className="camera-feed" />
  )}
</div>
          {!docImage ? (
            <button className="capture-btn" onClick={captureDoc}>Capture Document</button>
          ) : (
            <button className="retake-btn" onClick={() => setDocImage(null)}>Retake Document</button>
          )}
        </div>

        {/* Step 2 - Only if Step 1 is complete */}
        <div className="camera-box">
          <h2>Step 2 - Selfie</h2>
          <h4>Place your face inside the oval to capture selfie image.</h4>
          <div className="webcam-wrapper">
  <div className="overlay oval" />
  {!selfieImage ? (
    docImage ? (
      <Webcam
        audio={false}
        ref={selfieCamRef}
        screenshotFormat="image/jpeg"
        videoConstraints={videoConstraints}
        className="camera-feed"
      />
    ) : (
      <div className="camera-feed d-flex align-items-center justify-content-center text-muted">
        
      </div>
    )
  ) : (
    <img src={selfieImage} alt="Selfie" className="camera-feed" />
  )}
</div>


{!selfieImage ? (
  <button
    className={`capture-btn ${!docImage ? 'disabled-btn' : ''}`}
    onClick={captureSelfie}
    disabled={!docImage}
  >
    Capture Selfie
  </button>
) : (
  <button className="retake-btn" onClick={() => setSelfieImage(null)}>Retake Selfie</button>
)}
        </div>
      </div>

      {docImage && selfieImage && (
        <button
          className="submit-btn"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? 'Submitting...' : 'Submit for Verification'}
        </button>
      )}
    </div>
  );
};

export default UploadPage;
